import { CardBrand } from './card-brand';
export const getCardBrand = (cardNumber) => {
    if (RegExp('^4,*').test(cardNumber)) {
        return CardBrand.Visa;
    }
    if (RegExp('^5(1|2|3|4|5),*').test(cardNumber) || RegExp('^2,*').test(cardNumber)) {
        return CardBrand.Master;
    }
    if (RegExp('^3(4|7),*').test(cardNumber)) {
        return CardBrand.American;
    }
    if (RegExp('^6(01|22|44|5),*').test(cardNumber)) {
        return CardBrand.Discover;
    }
    if (RegExp('^3(0|6|8),*').test(cardNumber)) {
        return CardBrand.Diners;
    }
    if (RegExp('^62,*').test(cardNumber)) {
        return CardBrand.UnionPay;
    }
    if (RegExp('^5(0|6|7|8),*').test(cardNumber) || RegExp('^6,*').test(cardNumber)) {
        return CardBrand.Maestro;
    }
    if (RegExp('^35,*').test(cardNumber)) {
        return CardBrand.Jcb;
    }
    return CardBrand.Other;
};
//# sourceMappingURL=get-card-brand.js.map